// This file is auto-generated by Kubb. Do not edit manually.
/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const selfPayConversionEntryPointTypeEnum = {
  SELF_PAY_CONVERSION: "SELF_PAY_CONVERSION",
} as const;

export type SelfPayConversionEntryPointTypeEnumKey =
  (typeof selfPayConversionEntryPointTypeEnum)[keyof typeof selfPayConversionEntryPointTypeEnum];

export const selfPayConversionTypeEnum = {
  VANCE_SELF_PAY_CONVERSION: "VANCE_SELF_PAY_CONVERSION",
} as const;

export type SelfPayConversionTypeEnumKey =
  (typeof selfPayConversionTypeEnum)[keyof typeof selfPayConversionTypeEnum];

export type SelfPayConversion = {
  /**
   * @type string
   */
  entryPointType: SelfPayConversionEntryPointTypeEnumKey;
  /**
   * @type string
   */
  memberId: string;
  /**
   * @type string
   */
  state: string;
  /**
   * @type string
   */
  type: SelfPayConversionTypeEnumKey;
  /**
   * @type string
   */
  workspaceId: string;
};
